import { GROUP_CART_ADD_ITEMS, GROUP_CART_ADD_ITEMS_FAIL, GROUP_CART_ADD_ITEMS_SUCCESS, GROUP_CART_CREATE, GROUP_CART_CREATE_FAIL, GROUP_CART_CREATE_SUCCESS, GROUP_CART_LIST, GROUP_CART_LIST_FAIL, GROUP_CART_LIST_SUCCESS, GROUP_CART_SINGLE, GROUP_CART_SINGLE_FAIL, GROUP_CART_SINGLE_SUCCESS, INVITE_MEMBER, INVITE_MEMBER_FAIL, INVITE_MEMBER_SUCCESS, UNASSIGNED_ITEMS, UNASSIGNED_ITEMS_FAIL, UNASSIGNED_ITEMS_SUCCESS } from "../actions/group-cart-actions";

import { API } from "../api";
import { call, put, takeLatest, takeLeading } from "redux-saga/effects";


function* groupCart(action) {
    try {
        const response = yield call(API.groupCart, action.payload);
        yield put({ type: GROUP_CART_LIST_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: GROUP_CART_LIST_FAIL, payload: { error: error } });
    }
}
function* unassigned(action) {
    try {
        const response = yield call(API.unassignedItems, action.payload);
        yield put({ type: UNASSIGNED_ITEMS_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: UNASSIGNED_ITEMS_FAIL, payload: { error: error } });
    }
}
function* groupCartCreate(action) {
    const { payload, onSuccess, onError } = action;
    try {
        const response = yield call(API.groupCartCreate, payload);
        if (typeof onSuccess === "function") {
            yield call(onSuccess, response.data);
        }
        yield put({ type: GROUP_CART_CREATE_SUCCESS, payload: response.data });
    } catch (error) {
        if (typeof onError === "function") {
            yield call(onError, error);
        }
        yield put({ type: GROUP_CART_CREATE_FAIL, payload: { error } });
    }
}
function* inviteMember(action) {
    const { payload, onSuccess, onError } = action;
    try {
        const response = yield call(API.inviteMember, payload);

        if (typeof onSuccess === "function") {
            yield call(onSuccess, response.data);
        }

        yield put({ type: INVITE_MEMBER_SUCCESS, payload: response.data });
    } catch (error) {
        const errorMessage =
            error?.data?.message || 
            error?.message || 
            "Something went wrong. Please try again.";

        if (typeof onError === "function") {
            yield call(onError, errorMessage);
        }

        yield put({ type: INVITE_MEMBER_FAIL, payload: { error: errorMessage } });
    }
}

  
function* addItemsSaga(action) {
    const { payload, onSuccess, onError } = action;

    try {
        const response = yield call(API.addItemsApi, payload);
        if (typeof onSuccess === "function") {
            yield call(onSuccess, response.data);
        }
        yield put({ type: GROUP_CART_ADD_ITEMS_SUCCESS, payload: response.data });
    } catch (error) {
        if (typeof onError === "function") {
            yield call(onError, error);
        }
        yield put({ type: GROUP_CART_ADD_ITEMS_FAIL, payload: { error } });
    }
}
function* groupCartSingleSaga(action) {
    try {
        const response = yield call(API.groupCartSingle, action.payload.id);
        yield put({ type: GROUP_CART_SINGLE_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: GROUP_CART_SINGLE_FAIL, payload: { error } });
    }
}


function* groupCartSaga() {
    yield takeLatest(GROUP_CART_LIST, groupCart);
    yield takeLatest(UNASSIGNED_ITEMS, unassigned);
    yield takeLeading(GROUP_CART_CREATE, groupCartCreate);
    yield takeLatest(GROUP_CART_SINGLE, groupCartSingleSaga);
    yield takeLeading(GROUP_CART_ADD_ITEMS, addItemsSaga);
    yield takeLatest(INVITE_MEMBER, inviteMember);

}
export default groupCartSaga;




